import React, { useRef } from 'react'

// components
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
import FutureReservations from './components/FutureReservations/FutureReservations'
import PastReservations from './components/PastReservations/PastReservations'
import MyReservationsPageHead from './components/MyReservationsPageHead/MyReservationsPageHead'

// types
import { MyReservationsPageQuery, PageProps } from '../../types/types'

// hooks
import useMessages from '../../hooks/useMessages'

// styles
import * as SC from './MyReservationsPageStyles'

// utils
import createPageContainer from '../../utils/createPageContainer'

type RouteProps = {}
type MyReservationsPageData = {}

type MyReservationsPageProps = PageProps<MyReservationsPageData, MyReservationsPageQuery, RouteProps>

const MyReservationsPage = (props: MyReservationsPageProps) => {
	const { query, setQuery } = props

	const { messages } = useMessages()

	const pastReservationsContainerRef = useRef<HTMLDivElement>(null)

	const breadcrumbItems = [{ link: '', name: messages['My reservations'] }]

	return (
		<>
			<MyReservationsPageHead />
			<SC.PageContainer>
				<Breadcrumb breadcrumbItems={breadcrumbItems} hasSalonsBreadcrumb />
				<SC.MainTitle>{messages['My reservations']}</SC.MainTitle>
				<SC.MainContent>
					<SC.ReservationsContainer>
						<SC.SubTitle>{messages['Upcoming reservations']}</SC.SubTitle>
						<FutureReservations />
					</SC.ReservationsContainer>

					<SC.ReservationsContainer ref={pastReservationsContainerRef}>
						<SC.SubTitle>{messages['Past reservations']}</SC.SubTitle>
						<PastReservations query={query} setQuery={setQuery} pastReservationsContainerRef={pastReservationsContainerRef} />
					</SC.ReservationsContainer>
				</SC.MainContent>
			</SC.PageContainer>
		</>
	)
}

// page container
const MyReservationsPageContainer = createPageContainer<MyReservationsPageData, MyReservationsPageQuery, RouteProps>({
	identifier: 'MyReservationsPage',
	PageComponent: MyReservationsPage,
	initDefaultData: async () => {
		return {}
	}
})

export default MyReservationsPageContainer
